module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-18-3622d7f0e8504fcf79496d66c5f1e888.jpg";